// Anthropic SDK loader. Lazy-imported so the SDK (~50KB gzipped)
// only lands when the user actually falls back to Claude. The
// constructor promise and client instance are cached.

import type Anthropic from "@anthropic-ai/sdk";

let ctorPromise: Promise<typeof Anthropic> | null = null;
let cached: Anthropic | null = null;
let cachedKey: string | null = null;

function loadAnthropic(): Promise<typeof Anthropic> {
  if (!ctorPromise) {
    ctorPromise = import("@anthropic-ai/sdk").then((m) => m.default);
  }
  return ctorPromise;
}

export async function getClient(apiKey: string): Promise<Anthropic> {
  if (cached && cachedKey === apiKey) return cached;
  const Ctor = await loadAnthropic();
  cached = new Ctor({ apiKey, dangerouslyAllowBrowser: true });
  cachedKey = apiKey;
  return cached;
}

export const DEFAULT_MODEL = "claude-opus-4-7";
